import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { getOnboardingServicesUrlPublic } from 'pricing-pages-lib/utils/publicPageUrls';
import { HUBSPOT_FOR_STARTUPS_SETUP } from 'self-service-api/constants/ApiNames';
import { useErrorBoundary } from '../../../v2/components/error-boundary/useErrorBoundary';
import { trackClickedLink } from '../../../v2/utils/tracking/trackingEventUtils';
import { useOneTimeFeePricingForProducts } from '../../hooks/pricing/useGrowthPurchaseOptions';
import { SingleSkeletonLoader } from '../SingleSkeletonLoader';
import { CustomError } from '../error-boundary/CustomErrors';
import { RequiredOnboardingSubtextContent } from './RequiredOnboardingSubtextContent';
import { jsx as _jsx } from "react/jsx-runtime";
const RequiredOnboardingSubtext = ({
  productApiNames,
  langKey,
  currencyCode,
  tab,
  trackingSource,
  includesOnboardingCost
}) => {
  var _pricingInfo$oneTimeF, _pricingInfo$oneTimeF2;
  const {
    showBoundary
  } = useErrorBoundary();
  const onboardingServicesUrl = getOnboardingServicesUrlPublic(HUBSPOT_FOR_STARTUPS_SETUP === langKey);
  const handleClick = () => {
    trackClickedLink({
      name: 'onboarding-services',
      value: getI18nText('pricing-pages-ui.merchCardsV2.requiredOnboardingSubtext.learnMore', {
        locale: 'en-us'
      }),
      type: 'external',
      url: onboardingServicesUrl,
      tab,
      trackingSource
    });
  };
  const onboardingIncludedKey = includesOnboardingCost ? 'onboardingIncluded' : 'onboardingNotIncluded';
  const {
    pricingData: pricingInfo,
    loading: pricingLoading,
    error: pricingError
  } = useOneTimeFeePricingForProducts({
    productApiNames
  });
  if (pricingError) {
    showBoundary(new CustomError('Error fetching required onboarding pricing data', {
      error: pricingError,
      productApiNames
    }));
  }
  const fullPrice = pricingInfo === null || pricingInfo === void 0 || (_pricingInfo$oneTimeF = pricingInfo.oneTimeFee) === null || _pricingInfo$oneTimeF === void 0 ? void 0 : _pricingInfo$oneTimeF.fullPrice;
  const calculatedPrice = pricingInfo === null || pricingInfo === void 0 || (_pricingInfo$oneTimeF2 = pricingInfo.oneTimeFee) === null || _pricingInfo$oneTimeF2 === void 0 ? void 0 : _pricingInfo$oneTimeF2.calculatedPrice;
  const isLoading = pricingLoading;
  if ((!(pricingInfo !== null && pricingInfo !== void 0 && pricingInfo.oneTimeFee) || !fullPrice || !calculatedPrice) && !isLoading) {
    return null;
  }
  if (isLoading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 40,
      width: "100%"
    });
  }
  return /*#__PURE__*/_jsx(RequiredOnboardingSubtextContent, {
    langKey: langKey,
    currencyCode: currencyCode,
    fullPrice: fullPrice,
    calculatedPrice: calculatedPrice,
    onboardingIncludedKey: onboardingIncludedKey,
    handleClick: handleClick,
    onboardingServicesUrl: onboardingServicesUrl
  });
};
export default RequiredOnboardingSubtext;